/* React-Redux */
import {
  createSlice,
  PayloadAction,
} from "@reduxjs/toolkit";

import { fetchDescriptiveStatistics } from "src/redux/thunks/descriptive-statistics/descriptiveStatisticsThunk";

/* Interfaces */
import { BaseSliceProps } from "src/shared/interfaces/common/Slice";
import { BaseChartProps } from "src/shared/interfaces/charts/BaseChart";
import { DescriptiveStatisticsProps } from "src/shared/interfaces/DescriptiveStatistics";
import { ChartType } from "src/shared/constants/charts/Chart";

const initialState: BaseSliceProps<
  BaseChartProps<DescriptiveStatisticsProps, ChartType[]>
> = {
  data: undefined,
  isLoading: false,
  modifiedAt: undefined,
  error: undefined,
};

export const descriptiveStatisticsSlice = createSlice({
  name: "descriptiveStatistics",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      fetchDescriptiveStatistics.pending,
      (
        state: BaseSliceProps<
          BaseChartProps<
            DescriptiveStatisticsProps,
            ChartType[]
          >
        >
      ) => {
        if (!state.data) {
          state.isLoading = true;
          state.error = undefined;
        }
      }
    );
    builder.addCase(
      fetchDescriptiveStatistics.fulfilled,
      (
        state: BaseSliceProps<
          BaseChartProps<
            DescriptiveStatisticsProps,
            ChartType[]
          >
        >,
        action: PayloadAction<
          | BaseChartProps<
              DescriptiveStatisticsProps,
              ChartType[]
            >
          | undefined
        >
      ) => {
        const prevData = state.data;
        state.data = action.payload;

        if (
          prevData &&
          JSON.stringify(prevData) !==
            JSON.stringify(state.data)
        ) {
          state.modifiedAt = new Date().toISOString();
        }

        if (state.data) {
          state.isLoading = false;
        }
      }
    );
    builder.addCase(
      fetchDescriptiveStatistics.rejected,
      (state, action) => {
        state.isLoading = false;
        state.data = undefined;

        const error = action.payload;
        if (!error) return;

        state.error = action.payload;
      }
    );
  },
});

/* Reducer */
export default descriptiveStatisticsSlice.reducer;
